import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import StoreContext from './StoreContext';

class StoreProvider extends Component {

  render() {
    return (
      <StoreContext.Provider value={this.props.store}>
        { this.props.children }
      </StoreContext.Provider>
    );
  }

}

StoreProvider.propTypes = {
  store: PropTypes.shape({
    user: PropTypes.shape({
      username: PropTypes.string,
      admin: PropTypes.bool,
    }),
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export default StoreProvider;
